import { Enumify } from "enumify-ts";
import { CustomerProjectStageEnum } from "../routes/orders/api/Representation";
class CreationSourceType extends Enumify() {
    description;
    canChangeSavedProduct;
    canChangeCustomer;
    canChangeOrderRefAndDate;
    canEditFreight;
    canAddFreight;
    static CONSIGNMENT_API = new CreationSourceType('Consignment API Integration', false, false, false, false, false);
    static SALES_ORDER_API = new CreationSourceType('Sales Order API Integration', false, false, false, false, false);
    static RETAIL_EXPRESS_API = new CreationSourceType('Retail Express Integration', true, true, true, true, true);
    static ADMIN = new CreationSourceType('Admin Portal', true, true, true, true, true);
    static IMPORT = new CreationSourceType('Import (CSV etc)', true, true, true, true, true);
    static SCHEDULER = new CreationSourceType('Consignment Template Scheduler', true, true, true, true, true);
    static CONSUMER_APP = new CreationSourceType('Consumer App', true, true, true, true, true);
    static SHOPIFY = new CreationSourceType('Shopify', true, true, true, true, true);
    static SUBTRUX_SALES_ORDER = new CreationSourceType('Sales Order', false, false, false, true, false);
    static _ = CreationSourceType._closeEnum();
    // Do not believe the no usages reporting by intellij - it's wrong
    constructor(description, canChangeSavedProduct, canChangeCustomer, canChangeOrderRefAndDate, canEditFreight, canAddFreight) {
        super();
        this.description = description;
        this.canChangeSavedProduct = canChangeSavedProduct;
        this.canChangeCustomer = canChangeCustomer;
        this.canChangeOrderRefAndDate = canChangeOrderRefAndDate;
        this.canEditFreight = canEditFreight;
        this.canAddFreight = canAddFreight;
    }
    // Do not believe the no usages reporting by intellij - it's wrong
    isPickupReadOnlyForProjectStage(customerProjectStage) {
        if (this == CreationSourceType.SUBTRUX_SALES_ORDER) {
            return customerProjectStage != CustomerProjectStageEnum.ORDER && customerProjectStage != CustomerProjectStageEnum.PRE_ORDER;
        }
        return false;
    }
}
export default CreationSourceType;
